import i18n from 'l10n';
import GenericView from 'js/views/generic.view';
import Template from 'js/templates/subscriber.listgroup.row.hbs';
import {_} from 'backboneAdapter';
import {on, template} from "../adapters/backbone-decorators";

require('interfaceAdapter');

@template(Template)
class SubscriberListgroupRowView extends GenericView {

    constructor(options) {
        super(options);
        this.model.set("hasEmail", !!this.model.get('subscriber').email);
        this.model.set("hasSms", !!this.model.get('msisdn'));
        this.model.on('change', this.render, this); // When an attribute of the model changes value this will invoke render of this subscriber.
    }

    render() {
        const theId = this.model.get(this.model.idAttribute);
        super.render();
        $(this.el).find(".icon-info-2").parent().bind("click", function () {
            document.location.href = "#" + theId;
        });
        $(this.el).draggable({
            helper() {
                const helper = $("<i class='icon-tellody-user fg-funkyOrange' style='font-size: 40px;'/>").css("z-index", 9999);
                $("body").append(helper);
                return helper;
            },
            cursorAt: {top: 0, left: 0},
            cancel: "button"
        }).data('model', this.model);
    }

    @on('click #toggleBlocked')
    toggleBlock() {
        const $size = $('#size-contact');
        const $count = $('#count-blocked');
        const count = $size.text();
        $count.text(i18n.t("contacts.countBlocked", {count: this.toggleGenericCallback(1, count, 'status')}));
    }

    @on('click #toggleSmsBounced','bouncedSmsGroupGId', 'sms', 'Sms', 'smsBounced')
    @on('click #toggleEmailBounced', 'bouncedEmailGroupGId', 'email', 'Email', 'emailBounced')
    async toggleBouncingGeneric(endpoint, counterDiscriminator, dictionaryEntryDiscriminator, modelAttributeToUpdate) {
        const self = this;
        try {
            const groupId = await $.ajaxDefaultQ({
                url: `/CampaignCloud/Group/${endpoint}`,
                type: 'get',
                dataType: 'json'
            });
            if (groupId) {
                const $groupElement = $(`.group${groupId}`);
                const $count = $(`#count-${counterDiscriminator}-bounced`);
                const count = $groupElement.text();
                $count.text(i18n.t(`contacts.count${dictionaryEntryDiscriminator}Bounced`, {count: self.toggleGenericCallback(groupId, count, modelAttributeToUpdate)}));
            }
        } catch (error) {
            console.error(error);
        }
    }

    toggleGenericCallback(groupId, count, modelAttributeToUpdate) {
        if (this.model.get(modelAttributeToUpdate) === 1) {
            this.model.unblockContact(groupId);
            this.model.set(modelAttributeToUpdate, 0); // Render will be called.
            return parseInt(count) - 1;
        } else {
            this.model.blockContact(groupId);
            this.model.set(modelAttributeToUpdate, 1); // Render will be called.
            return parseInt(count) + 1;
        }
    }

    @on('click .moreOptions')
    @on('mouseenter .contactMoreOptions', _, true)
    @on('mouseleave .contactMoreOptions', _, false)
    toggleMoreOptions(e, flag) {
        e.stopPropagation();
        const el = $(e.currentTarget).find('span');
        el.toggleClass('visibleInlineBlock', flag !== undefined ? flag : !el.hasClass('visibleInlineBlock'));
    }
}

export default SubscriberListgroupRowView;
